import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const SelectedFilterInfo = styled<any, any>(
    'div',
    'selectedFilterInfo',
    'filterItemDropdown'
)`
    ${propStyles};
`;

SelectedFilterInfo.defaultProps = {
    display: 'flex',
};

export default SelectedFilterInfo;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/SelectedFilterInfo.tsx